<template>
  <div>
    
    
    <!-- <MenuSuperior></MenuSuperior> -->
    <!--  <MenuResponsivo></MenuResponsivo> -->
    <!-- <MenuMicrositio :key="cambiarRutaMenu"></MenuMicrositio> -->
    <!-- <VisorDeDocumentos></VisorDeDocumentos> -->
    <!-- <Micrositio :key="cambiarSubmenu"></Micrositio>  -->
    <div id="web-container">
      
      <transition name="fade" mode="out-in">
        <router-view :key="$route.path"></router-view>
      </transition>
    <!-- <MenuInferiorMicrositio :key="cambiarRutaMenu"></MenuInferiorMicrositio> -->


<!-- Modal -->


    </div>

  </div>
</template>


<script>
  import MenuSuperior from '@/components/PaginaOficial/Comun/MenuSuperior/MenuSuperior.vue';
  import MenuResponsivo from '@/components/PaginaOficial/Comun/MenuResponsivo/MenuResponsivo.vue';
  import MenuMicrositio from '@/components/Micrositios/Comun/MenuMicrositio/MenuMicrositio.vue';
  import VisorDeDocumentos from "@/components/PaginaOficial/Comun/VisorDeDocumentos.vue";
  import MenuInferiorMicrositio from "@/components/Micrositios/Comun/MenuInferiorMicrositio.vue";
  // import Micrositio from '@/components/Micrositios/Micrositio.vue';
  import api from '@/../static/js/api'
  import axios from 'axios'
  import { mapActions } from 'vuex'

  export default {
    name: `Plantilla`,
    data(){
      return{
        videoRuta:'',
        autoplay:0
      }
    },
    components: {
      MenuSuperior,
      MenuResponsivo,
      MenuMicrositio,
      VisorDeDocumentos,
      MenuInferiorMicrositio
      // Micrositio
    },
    computed: {
      // cambiarRutaMenu() {
      //   var ruta = this.$route.path.split('/');
      //   if (ruta[3] == "Home") {   
      //     this.$store.dispatch("A_SICPO_Micrositio_MenuRuta",this.$route.path);     
      //  }  else{
      //    var newRuta = '/'+ruta[1]+'/'+ruta[2] +'/Home' 
      //    this.$store.dispatch("A_SICPO_Micrositio_MenuRuta",newRuta); 
        
      //  }
      //    return this.$store.getters.Get_SICPO_Micrositio_MenuRuta;
      // },
      // rutaVideo(){
      //    this.videoRuta=this.$store.getters.Get_SICPO_Micrositio_RutaVideo.Ruta;
      //    return this.videoRuta;
      // }
    },

  

  
  }
</script>

<style>


  #web-container {
    background-color: #FFFFFF;
    min-height: calc(100vh - 103px);
    color: #111;
  }

  .page-text {
    /*white-space: pre;*/
    white-space: pre-wrap;
    text-align: justify;
  }

  .page-title {
    text-align: center;
    font-size: 3em;
    padding: 10px 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Audiencias/VistaMonitor/Plantilla.vue